// extracted by mini-css-extract-plugin
module.exports = {"root":"StateCard_root__3m7Gg","image":"StateCard_image__3OSeQ","imageOverlay":"StateCard_imageOverlay__3OiYk","title":"StateCard_title__3Kt10"};